import React from 'react'
import '../../Styles/Course_Offering.css'
import { Grid, Typography, Box } from '@mui/material'
import JSONDATA from '../../Assets/JSON/MV.json'
import { useNavigate } from 'react-router-dom'
import Course_Offering_Header from '../../Assets/Images/Courses_Header.png'

const Course_Offering = () => {
  const navigate = useNavigate()

  const Navigation_Sub_route = (data, dep) => {
    const selected_data = { College: data, CourseOffered: dep }
    navigate(
      '/courseoffering/' +
        data.title.toLowerCase().replace(/ /g, '-') +
        '/' +
        dep.title.toLowerCase().replace(/ /g, '-'),
      { state: { College_details: selected_data } }
    )
  }

  return (
    <Box className="Course_Header" sx={{ padding: { xs: '16px', sm: '32px' } }}>
      {/* Responsive Header Image */}
      <Box sx={{ textAlign: 'center', marginBottom: '24px' }}>
        <img
          src={Course_Offering_Header}
          alt="Course Offering"
          loading="lazy"
          placeholder="blur"
          style={{
            maxWidth: '80vw', // Adjust the max width to fit your needs
            height: 'auto', // Maintain aspect ratio
            margin: '0 auto', // Center the image horizontally
          }}
        />
      </Box>
      {/* Responsive Grid Container */}
      <Grid container spacing={4} justifyContent="center">
        {JSONDATA.sub_heading?.map((subItem, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            {/* Subheading Section */}
            <Box
              sx={{
                padding: '16px',
                borderRadius: '8px',
                textAlign: 'center',
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 'bold',
                  marginBottom: '16px',
                  color: '#ffffff',
                }}
              >
                {subItem.title}
              </Typography>

              {/* Subdepartment List */}
              <Grid container spacing={2}>
                {subItem.subdeparment?.map((subData, subDataIndex) => (
                  <Grid item xs={6} key={subDataIndex}>
                    <Typography
                      variant="body1"
                      onClick={() => Navigation_Sub_route(subItem, subData)}
                      sx={{
                        cursor: 'pointer',
                        color: '#ffffff',
                        '&:hover': {
                          textDecoration: 'underline',
                        },
                      }}
                    >
                      {subData.title}
                    </Typography>
                  </Grid>
                ))}
              </Grid>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  )
}

export default Course_Offering
